'use client';
var classes = {"root":"m-7f854edf"};

export default classes;
//# sourceMappingURL=Affix.module.mjs.map
